import {
    ControllerRouteResponse,
    ControllerRouteResponseType
} from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/ControllerRouteResponse";
import { BaseController } from "./BaseController";
import { RgbColor } from "@game.object/ts-game-toolbox/dist/src/data/RgbColor";

export class GameController extends BaseController {

    /**
     * Start a new game
     */
    public new_game(): ControllerRouteResponse {
        let last_hash = 0;
        for (let i = 0; i < 0; ++i) {
            let block = this.models.blocks.insert_new();
            block.previous_hash = last_hash;
            block.data = "+++++++Hello+++++++++";
            block.mine();
            last_hash = block.hash;
        }
        const response: ControllerRouteResponseType = {
            view: this.views.main.blocks.set(this.models.blocks.all()).chained_block_ids.set([]),
            controller: this.controllers.for_event.game_controller,
        };
        return response;
    }

}